"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useLabelBtnStyles = () => {
    const theme = (0, material_1.useTheme)();
    const btn = {
        textTransform: 'none',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: 0,
        color: `${theme.qlub.palette.black.main} !important`,
        '& .MuiButton-endIcon': {
            marginX: '1rem !important',
            fontSize: '1rem !important',
            'html[dir="rtl"] &': {
                transform: 'rotate(180deg)',
            },
            '> svg': {
                fontSize: '1rem !important',
            },
        },
    };
    const text = {
        padding: '0.875rem 1.5rem',
    };
    return {
        btn,
        text,
    };
};
exports.default = useLabelBtnStyles;
